import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import IcmsCstService from 'business/cadastro/fiscal/icmsCst/icmsCstService'
import ControllerInput from 'base/ControllerInput'
import GridForm from 'base/GridForm'
import { yupResolver } from '@hookform/resolvers/yup'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import { TabView, TabPanel } from 'primereact/tabview'
import { createCodeDescriptionObject } from 'helper/formater'
import { defaultEmptySelection } from 'helper/default'
import { errorToToast } from 'helper/error'

import RegimeTributacaoService from 'business/cadastro/fiscal/regimeTributacao/regimeTributacaoService'

export default function IcmsCst() {

    const [service] = useState(() => new IcmsCstService())
    const [regimeTributacaos, setRegimeTributacaos] = useState([])

    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data?.regime_tributacao) {
            setRegimeTributacaos([createCodeDescriptionObject(data.regime_tributacao, 'codigo_regit', 'descricao_regit', true)])
        }

        return data
    }

    const beforeSubmit = (data) => {
        let submitData = structuredClone(data)
        submitData = service.prepareToSave({ data: submitData })
        return submitData
    }

    useEffect(() => {
        service.getSchema().then(e => {
            setValidations(e)
        })
    }, [service])

    const loadRegimeTributacaos = async () => {
        const regit = new RegimeTributacaoService()
        await regit.list('').then(rs => {
            const options = rs.data.data.map(e => createCodeDescriptionObject(e, 'codigo_regit', 'descricao_regit', true))
            options.push({ codigo_regit: null, descricao_regit: defaultEmptySelection() })
            setRegimeTributacaos(options)
        }).catch(err => errorToToast({ err, toast }))
    }

    return (
        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast} beforeSubmit={beforeSubmit}>

            <TabView ref={stepperRef} className='text-sm' style={{ flexBasis: '1rem' }}>

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">

                    <GridForm>

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-4" field="descricao_icmcst" form={form} service={service} type="text" clearString label="Descrição" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_icms_icmcst" form={form} service={service} type="switch" label="Tem ICMS" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_st_icmcst" form={form} service={service} type="switch" label="Tem ST" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_antec_st_icmcst" form={form} service={service} type="switch" label="Tem antecipação ST" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_redu_bc_icmcst" form={form} service={service} type="switch" label="Tem redução BC" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_isencao_icmcst" form={form} service={service} type="switch" label="Tem isenção" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_dir_cred_icmcst" form={form} service={service} type="switch" label="Dá crédito" />
                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="tem_difer_icmcst" form={form} service={service} type="switch" label="Tem diferimento" />

                        <ControllerInput addClassName="md:col-6 lg:col-4 xl:col-2" field="cod_regit_icmcst" form={form} type="dropdown2" service={service} label="Regime de tributação"
                            optionKey='codigo_regit'
                            optionLabel='descricao_regit'
                            options={regimeTributacaos}
                            onLoad={loadRegimeTributacaos}
                        />

                    </GridForm>

                </TabPanel>

            </TabView>

        </FormCadastro>
    )
}
